import * as apiContract from '@/api/contract'
import { formatDateKanji } from '@/util/common'
import * as _ from 'lodash'
import { PACKAGE_STATUS, PACKAGE_STATUS_NAME, PRODUCT_STATUS, PRODUCT_CLASSIFICATION } from '@/util/constants'
// import * as 

const getDefaultState = () => {
  const defaults = {
    package_lists: [
      {
        package_name: null,
        package_status: null,
        period_start: null,
        period_end: null,
        license_classification: null,
        status: null,
        type: null,
        product_lists: [
          {
            name: null,
            code: null,
            classification: null,
            license: null,
            license_number: null,
            cancel_license_number: null,
            license_classification: null,
            status: null,
            period_start: null,
            period_end: null,
            using_license: [
              {
                user_id: null,
                user_name: null
              }
            ]
          }
        ]
      }
    ],
    selectPackage: null,
    selectProduct: null
  }
  return defaults
}

const contractPack = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    // 詳細画面へ遷移可能なパッケージリスト
    visibleDetailPackage: state => _.filter(state.package_lists, (item) => PACKAGE_STATUS.VISIBLE_DETAIL_PACKAGE.includes(item.package_status)),
    signedProductsInSignedPackages: (state, getters) => {
      const signedPackages = getters.visibleDetailPackage
      _.each(signedPackages, (pack) => {
        pack.product_lists = _.filter(pack.product_lists, product => {
          return _.includes(PRODUCT_STATUS.SIGNED_PRODUCT_INCLUDE_TRIAL, product.status)
        })
      })

      return _.filter(signedPackages, pack => pack.product_lists.length > 0)
    },
    getPurchaseList: (state, getters) => _.map(getters.edited, list => {
      return {
        code: list.code,
        num: list.purchase
      }
    }),
    // トライアル可能なパッケージリスト
    canTrialPackage: state => _.filter(state.package_lists, (item) => PACKAGE_STATUS.CAN_TRIAL_PACKAGE.includes(item.package_status)),
    canTrialProduct: (state, getters) => {
      const canTrialPack = getters.canTrialPackage
      const productLists = _.flatten(_.map(canTrialPack, pack => pack.product_lists))
      // 基本ライセンスで旧SNOLパッケージで無ければトライアルの申請は可能。
      return _.filter(productLists, product => product.classification === 1 && product.license_classification !== 2)
    },
    // 契約中のパッケージリスト
    signedPackage: state => _.filter(state.package_lists, (item) => PACKAGE_STATUS.SIGNED_PACKAGE.includes(item.package_status)),
    // 契約中のパッケージリスト（旧商品をのぞく）
    signedNewPackage: (state, getters) => _.filter(getters.signedPackage, (item) => item.license_classification === 1),
    // 契約中のパッケージリスト（旧商品をのぞく）内の商品リスト。DOM構造にあわせて加工
    signedNewPackageProduct: (state, getters) => {
      const signedNewPackage = _.map(getters.signedNewPackage, (pack, packIndex) => {
        // 購入できるもののみ表示
        const products = _.filter(pack.product_lists, product => PRODUCT_CLASSIFICATION.BUY.includes(product.classification))
        return _.map(products, tmpProduct => {
          const product = Object.assign({}, tmpProduct)
          product.package_master_status = pack.package_master_status
          product.package_name = pack.package_name
          product.packIndex = 'signed_' + packIndex + 1
          // product.count = products.length // 廃止：カウントは最終的なフィルタリングを適用してから集計し直さないとズレるのでここでは設定しない
          const min = (product.license > product.license_number)
            ? product.license - product.license_number
            : 0
          // 購入可能数を固定ライセンス数と現在のトータルライセンス数から割り出し、selectに渡せる値(object)に変換する
          product.select = _.map(_.filter([...Array(100).keys()], index => {
            return index >= min
          }), value => {
            return { name: value, value: value }
          })
          delete product.using_license

          return product
        })
      })

      // package->productの配列をフラットにしproductの配列にする
      return _.flatten(signedNewPackage)
    },
    // 契約中のパッケージリスト内の「契約中」商品リスト。DOM構造にあわせて加工
    signedPackageProduct: (state, getters) => {
      const signedPackage = _.map(getters.signedPackage, (pack, packIndex) => {
        const signedProducts = _.filter(pack.product_lists, product => PRODUCT_STATUS.SIGNED_PRODUCT.includes(product.status))
        return _.map(signedProducts, tmpProduct => {
          const product = Object.assign({}, tmpProduct)
          product.package_name = pack.package_name
          product.packIndex = 'signed_' + packIndex + 1
          // product.count = signedProducts.length // 廃止：カウントは最終的なフィルタリングを適用してから集計し直さないとズレるのでここでは設定しない

          const max = product.license_number - product.license ?? 0
          // 解約可能数を固定ライセンス数と現在のトータルライセンス数から割り出し、selectに渡せる値(object)に変換する
          product.select = max > 0 ? _.map([...Array(max + 1).keys()], value => {
            return { name: value, value: value }
          }) : 0
          
          // ライセンス数＞設定ユーザー数の判定に使用する
          // delete product.using_license

          return product
        })
      })
      
      // package->productの配列をフラットにしproductの配列にする
      return _.flatten(signedPackage)
    },
    // テーブル用の契約中商品リスト
    signedPackageProductForTable: (state, getters) => {
      const signedPackage = _.map(state.package_lists, pack => {
        const signedProducts = _.filter(pack.product_lists, product => PRODUCT_STATUS.SIGNED_PRODUCT_INCLUDE_TRIAL.includes(product.status))
        return _.map(signedProducts, tmpProduct => {
          const product = Object.assign({}, tmpProduct)
          product.package_name = pack.package_name
          product.count = signedProducts.length

          return product
        })
      })

      // package->productの配列をフラットにしproductの配列にする
      return _.flatten(signedPackage)
    },
    // 未契約のパッケージリスト
    unsignedPackage: state => _.filter(state.package_lists, (item) => PACKAGE_STATUS.UNSIGNED_PACKAGE.includes(item.package_status)),
    // 未契約のパッケージリスト（旧商品をのぞく）
    unsignedNewPackage: (state, getters) => _.filter(getters.unsignedPackage, (item) => item.license_classification === 1),
    // 未契約のパッケージリスト（旧商品をのぞく）内の商品リスト。DOM構造にあわせて加工
    unsignedNewPackageProduct: (state, getters) => {
      const unsignedNewPackage = _.map(getters.unsignedNewPackage, (pack, packIndex) => {
        // 購入できるもののみ表示
        const products = _.filter(pack.product_lists, product => PRODUCT_CLASSIFICATION.BUY.includes(product.classification))
        const packageName = pack.package_name
        return _.map(products, tmpProduct => {
          const product = Object.assign({}, tmpProduct)
          product.package_name = packageName
          product.packIndex = 'unsigned_' + packIndex + 1
          // product.count = pack.product_lists.length
          product.count = products.length
          const min = (product.license > product.license_number)
            ? product.license - product.license_number
            : 0
          // 購入可能数を固定ライセンス数と現在のトータルライセンス数から割り出し、selectに渡せる値(object)に変換する
          product.select = _.map(_.filter([...Array(100).keys()], index => {
            // return index === 0 || index >= min
            return index >= min
          }), value => {
            return { name: value, value: value }
          })
          delete product.using_license

          return product
        })
      })
      
      // package->productの配列をフラットにしproductの配列にする
      return _.flatten(unsignedNewPackage)
    },
    // パッケージステータスの論理名
    packageStatusWord: state => status => PACKAGE_STATUS_NAME(status),
    // 有効期限
    packageEnd: state => periodEnd => {
      const dateFormat = formatDateKanji(periodEnd)
      const peripd = `有効期限は ${dateFormat} までです。`
      return dateFormat ? peripd : ''
    },
    // 選択中のパッケージが解約予約済みかどうか
    isCancelPackage: state => state.selectPackage.package_status === PACKAGE_STATUS.RESERVE_CANCEL,
    // 選択中のパッケージがトライアル中かどうか
    isTrialPackage: state => state.selectPackage.package_status === PACKAGE_STATUS.TRIAL,
    // 選択中のパッケージが未契約かどうか
    isUnSignedPackage: state => state.selectPackage.package_status === PACKAGE_STATUS.UNSIGNED,
    // 選択中のパッケージが旧商品かどうか
    isOldPackage: state => state.selectPackage.license_classification === 2,
    // 選択中のパッケージから基本商品を取得
    basicProduct: state => _.filter(state.selectPackage.product_lists, (item) => item.classification === 2),
    // 選択中のパッケージからオプション商品を取得
    optionProduct: state => _.filter(state.selectPackage.product_lists, (item) => item.classification === 3),
    // 選択中のパッケージからトライアル商品を取得
    trialProduct: state => _.filter(state.selectPackage.product_lists, (item) => item.classification === 1)
  },
  mutations: {
    setAllData(state, data) {
      Object.assign(state, data)
    },
    setSelectPackage(state, value) {
      state.selectPackage = value
    },
    resetSelectPackage(state) {
      state.selectPackage = null
    },
    setSelectProduct(state, value) {
      state.selectProduct = value
    },
    resetSelectProduct(state, value) {
      state.selectProduct = null
    }
  },
  actions: {
    // パッケージ情報の取得
    async getPackageData({ commit }) {
      await apiContract
        .listPackagesAndProducts()
        .then(response => {
          const data = response.data
          if (data.status === 0) {
            commit('setAllData', data)
          }
        })
    },
    async setSelectPackage({ commit }, value) {
      await commit('setSelectPackage', value)
    },
    async setSelectProduct({ commit }, value) {
      await commit('setSelectProduct', value)
    },
    async cancelCancellation({ commit, dispatch }, value) {
      const params = {
        type: 6, // 解約予約取り消し
        data: [
          { code: value.code }
        ]
      }
      const res = await apiContract
        .applyProducts(params)
        .then(async (response) => {
          const { data } = response
          if (data.status === 0) {
            await dispatch('getPackageData')
          } else {
            throw data
          }

          return data
        })
    
      return res
    }
  }
}

export default contractPack
